export default [{
  path: '/staffAssentReason',
  name: 'staffAssentReason',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/staffAssentReason/index')
}]
